export { default } from "./TeacherToolsTabs";
